import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {BankAccountServiceAPI, IBankAccountService} from '../model/bank-account-service';
import {mbeConfigService} from './mbe-config.service';
import {BasicResponse, ErrorService} from '@auth-suite-services/services';


@Injectable({
  providedIn: 'root'
})
export class BankAccountServiceService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(mbeConfigService) private config,
              private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  // tslint:disable-next-line:max-line-length
  // GetAllBankAccountService(pageIndex: number, pageSize: number, sortActive: string, sort: string, cin: number): Observable<BankAccountServiceAPI> {
  GetAllBankAccountService(pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    bacRno: number,
    bacGid?: number,
    allbas?: number,
    bcicaID?: number,
    tracer?: string,
    tracerNo?: string,): Observable<BankAccountServiceAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;

    
    const json = {
      // "bacRno":163,"bacGid":13,"allBas":0,"bcicaID":1,"tracer":"400022109"
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortActive: sortActive ? sortActive : 'id',
      sort: sort ? sort : 'asc',
      bacRno: bacRno ? bacRno : 0,
      bacGid: bacGid ? bacGid : 0,
      allBas: allbas ? allbas : 0,
      bcicaID: bcicaID ? bcicaID : '99',
      tracer: tracer ? tracer : '',
    };
    // tslint:disable-next-line:max-line-length
    // return this.httpClient.get<BankAccountServiceAPI>(`${this.URL}/bse/getallbankaccountservice/${pageIndex}/${pageSize}/${sortActive ? sortActive : 'id'}/${sort ? sort : 'asc'}/${cin ? cin : 0}`, {headers});
    return this.httpClient.post<BankAccountServiceAPI>(`${this.URL}/bse/getallbankaccountservice/`,json, {headers});
  }

  GetBankAccountService(id: number): Observable<IBankAccountService> {
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<IBankAccountService>(`${this.URL}/bse/getbankaccountservice/${id}`, {headers});
  }

  UpdateBankAccountService(bas: IBankAccountService): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update bfd: ' + JSON.stringify(bas));
    return this.httpClient.post<BasicResponse>(`${this.URL}/bse/updatebankaccountservice`, bas, {headers});
  }

  // Added new method to create a new Bank Account Service. 03/10/2025 PK.
  createBankAccountService(bas: IBankAccountService): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/bse/createbankaccountservice`, bas, {headers});
  }
}

